<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12" class="mt-1">
        <div class="dispatch-table">
          <b-card>
            <div slot="header">
              <span>Truck Max Dwell Time </span>
            </div>
            <tr>
              <td>
                <!-- <b-button
                  variant="primary"
                  @click="
                    $router.push(
                      '/Maintenance/637481313038913286/new/dwelltime'
                    )
                  "
                >
                  <i class="fa fa-plus-circle"></i>&nbsp;New Dwell Time
                </b-button> -->
              </td>
            </tr>
            <br />
            <b-table
              show-empty
              bordered
              responsive="sm"
              class="mb-0 table-outline"
              hover
              small
              autocomplete="off"
              striped
              fixed
              head-variant="light"
              :items="dwelltime"
              :fields="fields"
            >
              <template v-slot:cell(Edit)="data">
                  <b-button variant="primary" class="btn btn-warning btn-sm"
                  @click="editDwellTime(data.item.maxdwelltime, data.item.status, data.item.id)">
                    <i class="fa fa-pencil-square-o"></i>
                  </b-button>
                <!-- <router-link
                  tag="button"
                  :to="
                    '/Maintenance/637481313038913286/modify/dwelltime/' +
                    data.item.id
                  "
                  class="btn btn-warning btn-sm"
                >
                  <i class="fa fa-pencil-square-o"></i>
                </router-link> -->
              </template>
              <template v-slot:cell(maxdwelltime)>
                {{ maxdwelltime }}
              </template>
              <template v-slot:cell(status)="data">
                <i
                  :class="
                    data.item.status == 1
                      ? 'activeStatus icon-check active_icon'
                      : 'inactiveStatus icon-close inactive_icon'
                  "
                ></i>
              </template>
            </b-table>
          </b-card>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: function () {
    return {
      dwelltime: [],
      maxdwelltime: "",

      fields: [
        {
          key: "Edit",
          thStyle: { width: "5%" },
        },
        {
          key: "maxdwelltime",
          label: "Dwell Time",
        },
        {
          key: "status",
          label: "Status",
        },
      ],
    };
  },

  methods: {
    GetDwellTime() {
      var vm = this;
      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "dwelltime?brancode=" +
            vm.$store.getters.selectedWarehouse
        )
        .then((resp) => {
          vm.dwelltime = resp.data;
          // vm.maxdwelltime = vm.dwellcontainer[0].maxdwelltime;
          var h = Math.floor(this.dwelltime[0].maxdwelltime / 60);
          var m = Math.floor(this.dwelltime[0].maxdwelltime % 60);
          var s = Math.floor((this.dwelltime[0].maxdwelltime * 60) % 60);

          var hDisplay = h > 0 ? (h <= 9 ? "0" : "") + h : "00";
          var mDisplay = m > 0 ? (m <= 9 ? "0" : "") + m : "00";
          var sDisplay = s > 0 ? (s <= 9 ? "p" : "") + s : "00";
          vm.maxdwelltime = hDisplay + ":" + mDisplay + ":" + sDisplay;
          console.log(vm.dwelltime);
        })
        .catch(() => {
          return [];
        });
    },

    editDwellTime(time, status, id) {
        this.$store.state.maxdwell = time,
        this.$store.state.status = status
        this.$router.push('/Maintenance/637481313038913286/modify/dwelltime/' + id)
    }
  },

  created() {
    this.GetDwellTime();
  },
};
</script>
<style>
.nameOfTheClass {
  max-width: 30px;
}
</style>